import React, { useEffect } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';

const FinReg = (props) => {
    useEffect(() => {
    }, [])
    return (

        <Grid container justify="center">
            <Grid item>


                <Typography variant="h3">Sukses!</Typography>


                <br />
                <Typography variant="body1">
                    E-pos met verdere instruksies is gestuur aan {props.prop3.userEmail}.
                </Typography>

                <br />

                <Button onClick={() => props.history.push('/')}>Maak Klaar</Button>

            </Grid>
        </Grid>


    );
}


export default FinReg;



// WEBPACK FOOTER //
// ./src/components/FinReg.js